var _circle, _path, _path2, _circle2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMany(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 20.1113,
    r: 12,
    fill: "white",
    stroke: "#4B6D8A",
    strokeWidth: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 4.11133V7.61133",
    stroke: "#4B6D8A",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 4.11133H19.75",
    stroke: "#4B6D8A",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "matrix(1 0 0 -1 15 22.6113)",
    fill: "#F65252"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5556 12.2959C16.5783 11.7911 16.9941 11.3936 17.4994 11.3936C18.0046 11.3936 18.4205 11.7911 18.4432 12.2959L18.7934 20.0873C18.8265 20.8248 18.2376 21.4408 17.4994 21.4408C16.7612 21.4408 16.1722 20.8248 16.2054 20.0874L16.5556 12.2959Z",
    fill: "#F65252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMany);
export default __webpack_public_path__ + "static/media/many.03848e35d0397f06d81b203c072f4972.svg";
export { ForwardRef as ReactComponent };